import { FC, useMemo } from 'react';
import classNames from 'classnames';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import type { MoveGrade } from '@whitesharx/starfall-frontend-chessground';
import { usePlayerQuery } from '@whitesharx/starfall-frontend-core';
import { ProcessedAnalyzedMove } from '../../types';

import { containerStyles, sectionStyles, titleStyles, imageStyles, textStyles, lineStyles } from './styles.css';

import { colorStyles } from '../../styles.css';

type Props = {
  moves?: ProcessedAnalyzedMove[];
};

const INITIAL_LINE_WIDTH = 58;
const SYMBOL_WIDTH = 8;

const initialGrades: Record<MoveGrade, number> = {
  best: 0,
  great: 0,
  good: 0,
  slip: 0,
  mistake: 0,
  blunder: 0,
  'missed-win': 0,
};

const Grades: FC<Props> = ({ moves = [] }) => {
  const playerQuery = usePlayerQuery();
  const playerId = playerQuery.data?.player.id;

  const grades = useMemo(() => {
    if (!moves.length || !playerId || !moves.some((move) => move.score !== undefined)) {
      return null;
    }

    return moves.reduce(
      (acc, move) => {
        if (move.grade) {
          const gradesToUpdate = playerId === move.playerId ? acc.player : acc.enemy;
          gradesToUpdate[move.grade] += 1;
        }

        return acc;
      },
      {
        player: { ...initialGrades },
        enemy: { ...initialGrades },
      }
    );
  }, [moves, playerId]);

  if (!grades) {
    return null;
  }

  return (
    <div className={containerStyles}>
      {(Object.keys(initialGrades) as Array<MoveGrade>).map((key, index) => {
        const playerGrade = grades.player[key];
        const gradeWidth = SYMBOL_WIDTH * String(playerGrade).length;
        const lineWidth = INITIAL_LINE_WIDTH - gradeWidth;

        return (
          <div className={classNames(sectionStyles, colorStyles[key])} key={index}>
            <span style={{ width: `${gradeWidth}px` }}>{playerGrade}</span>
            <div className={lineStyles} style={{ width: `${lineWidth}px`, maxWidth: `${lineWidth}px` }} />
            <div className={titleStyles}>
              <img className={imageStyles} src={`/assets/move-grade-images/${key}-move.svg`} />
              <p className={textStyles}>{t(`analysis.${key}`)}</p>
            </div>
            <div className={lineStyles} />
            <span>{grades.enemy[key]}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Grades;
